import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import HostsCreateEditForm from './Components/HostsCreateEditForm';
import HostsApi from './HostsApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: HostsCreateEditForm,
                getCreate: HostsApi.create,
                defaults: {},
                successMessage: "Hosts Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}